export default __webpack_public_path__ + "static/media/torikata.0b31a6e2.png";